
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.655 12.137c-.223-.224-.502-.333-.875-.32a1.091 1.091 0 00-.807.469 10.61 10.61 0 00-.787 1.309 6.99 6.99 0 01-1.973-1.377 7.164 7.164 0 01-1.39-1.987c.42-.21.854-.475 1.301-.787.272-.19.441-.482.468-.807a1.118 1.118 0 00-.318-.882L3.672 4.153a1.107 1.107 0 00-1.553 0c-.122.122-1.235 1.248-1.9 2.768-1.186 2.72 2.768 7.013 4.03 8.281.997.99 4.463 4.22 7.115 4.22.407 0 .793-.075 1.132-.225 1.404-.61 2.47-1.6 2.768-1.899a1.114 1.114 0 00-.007-1.553l-3.602-3.602v-.006zm-.291 5.677c-1.737 0-4.592-2.367-5.962-3.724l-.048-.054C3.11 11.777 1.128 8.82 1.684 7.55c.353-.807.876-1.492 1.215-1.899l2.794 2.795c-.556.339-.963.515-1.173.59a.805.805 0 00-.495.976c.149.53.65 1.913 2.048 3.33 1.404 1.378 2.788 1.88 3.317 2.036a.81.81 0 00.97-.502c.074-.21.25-.617.59-1.174l2.794 2.795c-.4.346-1.085.861-1.899 1.214a1.24 1.24 0 01-.495.088l.014.014zM21.952.579H7.965a2.047 2.047 0 00-2.048 2.048v1.479l8.669 4.714a.778.778 0 00.732 0l7.15-3.927v7.86a.522.522 0 01-.523.523h-4.72a.807.807 0 00-.57 1.377c.081.095.2.15.325.15h4.972A2.051 2.051 0 0024 12.752V2.628A2.051 2.051 0 0021.952.58zm.522 2.048v.522L14.959 7.28 7.45 3.15v-.523c0-.292.237-.522.522-.522h13.98c.291 0 .522.237.522.522z","fill":"currentColor"}})])
          )
        }
      }
    